export const columns = [
  {
    title: '健管ID',
    dataIndex: 'daUcId'
  },
  {
    title: '健管姓名',
    dataIndex: 'daUserName'
  },
  {
    title: '评分',
    dataIndex: 'daEvaluationScore;',
    slots: { customRender: 'daEvaluationScore' }
  },
  {
    title: '评分时间',
    dataIndex: 'statisticsDate'
  }
]
export const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
